<template>
 <div>
   <ul class="flex flex-wrap mb-1">
     <li
         class="inline-flex items-center px-1 rounded-sm text-xxs mr-2 mb-2 h-5"
         v-for="(item, index) in data.product_tags"
         :key="index"
         :class="[ index === 0 ? {
                'bg-orange text-white': Number(data.cruise_product_type) === 2,
                'bg-purple text-white': Number(data.cruise_product_type) === 1
            } : 'border border-[#7378E6] text-[#7378E6]']"
     >{{ item }}</li>
   </ul>
   <template v-if="!isApiCruise">

     <div class="product-base-info">
       <span class="product-depart">{{ data.departure }}出发</span>
       <v-divider direction="vertical" />
       <span class="product-no">产品编号：{{ data.product_no }}</span>
       <div class="copy-no-btn">
         <i class="ficon ficon-fuzhi" title="复制" v-clipboard="() => data.product_no" v-clipboard:success="handleCopySuccess" v-clipboard:error="handleCopyError"></i>
       </div>
     </div>

   </template>
   <template v-else>
     <div class="product-boat-base-info">
         <div class="product-item">
           <p class="product-item__label">产品编号</p>
           <p class="product-item__content">
             <span class="product-no">{{ data.product_no }}</span>
             <i class="ficon ficon-fuzhi copy-no-btn" title="复制" v-clipboard="() => data.product_no" v-clipboard:success="handleCopySuccess" v-clipboard:error="handleCopyError"></i>
           </p>
         </div>
         <v-divider direction="vertical" class="product-divider" />
         <div class="product-item">
           <p class="product-item__label">登船港口</p>
           <p class="product-item__content"><span>{{data.on_pier}}</span></p>
         </div>
         <v-divider direction="vertical" class="product-divider" />
         <div class="product-item">
           <p class="product-item__label">登船日期</p>
           <p class="product-item__content"><span>{{data.departure_date}}</span></p>
         </div>
         <v-divider direction="vertical" class="product-divider" />
         <div class="product-item">
           <p class="product-item__label">行程天数</p>
           <p class="product-item__content"><span>{{data.days}}天</span></p>
         </div>
     </div>
   </template>
 </div>
</template>

<script>
import clipboard from "@/directives/clipboard";
import { CRUISE_PRODUCT_TYPE,CRUISE_CLASS } from "@/constants/const-http";

export default {
  props:{
    data:{
     type:Object,
     default:{}
    }
  },
  data(){
   return {

   }
  },
  methods: {
    handleCopySuccess() {
      this.$message.success("复制成功");
    },
    handleCopyError() {
      this.$message.error("复制失败");
    },
  },
  directives: {
    clipboard,
  },
  computed:{
    isApiCruise(){
      return this.data.class === CRUISE_PRODUCT_TYPE.API && [CRUISE_CLASS.OVERSEAS,CRUISE_CLASS.OCEAN,CRUISE_CLASS.POLAR].includes(this.data.class_id);
    },
  }
}
</script>

<style lang="scss" scoped>


::v-deep .product {
  &-depart {
    color: $color-grey-3;
    margin: 7px 0;
  }
  &-tag-group {
    margin: 12px 0;
    .v-tag--primary {
      background-color: #fef1d7;
      color: #ff9500;
    }
    .v-tag--blue {
      background-color: #e2f4f3;
      color: #00b1a6;
    }

    .tag {
      & + & {
        margin-left: 4px;
      }
    }
  }
  &-base-info {
    .product-no {
      color: $color-grey-3;
    }
    .copy-no-btn {
      padding: 0 5px;
      display: inline-block;
      cursor: pointer;
      user-select: none;
    }
  }
  &-boat-base-info{
    display: flex;
    justify-content: space-between;
    align-content: center;
    height: 64px;
    background: $color-white-1;
    border: 1px solid $color-grey-18;
    padding:10px 8px;
    box-sizing: border-box;
    .product-item{
      flex-direction: column;
      justify-content: space-between;
      flex:1;
      padding-left:8px;
      box-sizing: border-box;
      line-height:24px;
      &__label{
        font-size: 14px;
        font-weight: 400;
        color: #868E96;
      }
      &__content{
        font-size: 14px;
        font-weight: 500;
        color: #495057;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 280px;
      }
    }
  }
  &-divider{
    height: 44px;
    background: $color-grey-18;
  }
}

</style>
